import styled from 'styled-components';

export const TabsWrapper = styled.ul`
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0 24px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey200};
  overflow-x: auto;
`;

export const Tab = styled.li`
  cursor: pointer;
  font-weight: 400;
  font-size: 13px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.grey600};
  padding: 17px 16px;
  border-bottom: 4px solid transparent;
  transition: all 200ms;
  white-space: nowrap;
  ${({ active, theme }) =>
    active &&
    `
      color: ${theme.colors.blueMain};
      border-color: ${theme.colors.blueMain};
  `}
`;
